import {Component, ElementRef, EventEmitter, forwardRef, HostBinding, HostListener, Input, Output, ViewChild} from '@angular/core';
import {NG_VALUE_ACCESSOR} from '@angular/forms';
import {ControlStatus, Keys, PersistentInputComponent} from '@ideals/types';

export const CHIP_CONTROL_VALUE_ACCESSOR = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ChipComponent),
  multi: true
};

@Component({
  selector: 'ideals-chip',
  templateUrl: './chip.component.html',
  styleUrls: ['./chip.component.scss'],
  providers: [CHIP_CONTROL_VALUE_ACCESSOR]
})
export class ChipComponent extends PersistentInputComponent {

  @Input()
  public formControlName: number;

  @HostBinding('class.editing')
  public get editing(): boolean {
    return this._editing;
  }

  public set editing(value: boolean) {
    this._editing = value;
  }

  @Output()
  public edited = new EventEmitter();

  @Output()
  public crossClick = new EventEmitter<number>();

  @ViewChild('editor')
  public set editor(value: ElementRef) {
    this._editor = value.nativeElement as HTMLElement;
  }

  @HostBinding('class.invalid')
  public get invalid(): boolean {
    return this.formControl.status === ControlStatus.Invalid;
  }

  @HostBinding('class.pending')
  public get pending(): boolean {
    return this.formControl.status === ControlStatus.Pending;
  }

  private _editor: HTMLElement;
  private _editing: boolean;

  constructor() {
    super();
  }

  @HostListener('dblclick')
  public onDoubleClick(): void {
    this.editing = true;
    setTimeout(() => {
      this._editor.focus();
    });
  }

  public onBlur(): void {
    this._stopEditing();
  }

  public onKeydown(event: KeyboardEvent): void {
    if (event.key === Keys.Enter) {
      event.preventDefault();

      this._editor.blur();
    }
  }

  public onRemove(): void {
    this._doRemove();
  }

  private _stopEditing(): void {
    const caption = this._editor.innerText.trim();

    if (caption.length) {
      this.value.caption = caption;
      this.formControl.setValue(this.value);
      this.edited.emit();
    } else {
      this._doRemove();
    }

    this.editing = false;
  }

  private _doRemove(): void {
    this.crossClick.emit(this.formControlName);
  }
}
